export const formatMbps = (bps) => `${(bps / 1000000).toFixed(1)}`;
export const formatPercent = (fraction, digits = 1) => `${(fraction * 100).toFixed(digits)}%`;
export const formatDateTime = (value) => value ? new Date(value).toLocaleString() : "—";
export const splitDuration = (totalSeconds) => {
    const s = Math.max(0, Math.floor(totalSeconds));
    return {
        d: Math.floor(s / 86400),
        h: Math.floor((s % 86400) / 3600),
        m: Math.floor((s % 3600) / 60),
        s: s % 60,
    };
};
export const orDash = (value) => value === null || value === undefined || value === "" ? "—" : value;
